import text from './resources/locale/en.json';

class ManageButtons {
    $onInit() {
        this.text = text;
    }
}

export default ManageButtons;
